import { useMutation } from "react-query";
import api from "../../client";

// TODO: response
const postData = async (): Promise<object> => {
  const { data } = await api.post(`/auth/logout`);

  return data;
};

export const useLogout = () => {
  return useMutation(() => {
    return postData();
  });
};
